/*
  system-settings.js
    System settings module

*/
import * as types from '@/store/mutation-types'
import { sLog } from '@/common/simple-logger'
import { LS_SCREEN_LAYOUT, LS_DISP_ITEM, LS_CAROUSEL_INTERVAL } from '../../common'

export default {
  state: {
    // localStorageは文字列でgetされるので文字列で比較して、Booleanに変換している.
    //sScreenView: (localStorage.getItem(LS_SCREEN_VIEW) === 'true'),
    //sScreenColumn: (localStorage.getItem(LS_SCREEN_COLUMN) === 'true'),
    sScreenLayout: (localStorage.getItem(LS_SCREEN_LAYOUT) ? localStorage.getItem(LS_SCREEN_LAYOUT) : '00'),
    sDispItem: (localStorage.getItem(LS_DISP_ITEM) ? localStorage.getItem(LS_DISP_ITEM) : '1'),
    sCarouselInterval: (localStorage.getItem(LS_CAROUSEL_INTERVAL) ? localStorage.getItem(LS_CAROUSEL_INTERVAL) : '10'),
    sTelework: false,  // Telework mode
    sGnssReady: false,  // GeoLocation system ready
  },
  getters: {
    isScreenView: state => (state.sScreenLayout[0] !== '0'),
    screenLayout: state => state.sScreenLayout[1],
    dispItem: state => state.sDispItem,
    carouselInterval: state => state.sCaouselInterval,
    isTelework: state => state.sTelework,
    isGnssReady: state => state.sGnssReady,
  },
  actions: {
    /* ～ver2.5
    // Change screen view mode
    changeScreenView: ({ commit }, payload) => {
      sLog.debug('@action changeScreenView ' + payload)
      commit(types.CHANGE_SCREEN_VIEW, payload)
    },
    // Change columns for screen view mode
    changeScreenColumn: ({ commit }, payload) => {
      sLog.debug('@action changeScreenColumn ' + payload)
      commit(types.CHANGE_SCREEN_COLUMN, payload)
    },*/
    // Change screen layout
    changeScreenLayout: ({ commit }, payload) => {
      sLog.debug('@action changeScreenLayout ' + payload)
      commit(types.SET_SCREEN_LAYOUT, payload)
    },
    // Change disp item (screen mode)
    changeDispItem: ({ commit }, payload) => {
      sLog.debug('@action changeDispItem ' + payload)
      commit(types.SET_DISP_ITEM, payload)
    },
    // Change carousel interval (screen mode)
    changeCarouselInterval: ({ commit }, payload) => {
      sLog.debug('@action changeCarouselInterval ' + payload)
      commit(types.SET_CAROUSEL_INTERVAL, payload)
    },
    // Change Gnss ready
    changeGnssReady: ({ commit }, payload) => {
      sLog.debug('@action changeGnssReady ' + payload)
      commit(types.CHANGE_GNSS_READY, payload)
    },
    // Init browser menu settings
    // (true: localStorageから取得、false: 内部変数をクリア)
    initBrowserMenuSetting: ({ commit }, payload) => {
      sLog.debug('@action initBrowserMenuSetting ' + payload)
      if (payload === true) {
        commit(types.SET_SCREEN_LAYOUT, (localStorage.getItem(LS_SCREEN_LAYOUT) ? localStorage.getItem(LS_SCREEN_LAYOUT) : '00'))
        commit(types.SET_DISP_ITEM, (localStorage.getItem(LS_DISP_ITEM) ? localStorage.getItem(LS_DISP_ITEM) : '1'))
        commit(types.SET_CAROUSEL_INTERVAL, (localStorage.getItem(LS_CAROUSEL_INTERVAL) ? localStorage.getItem(LS_CAROUSEL_INTERVAL) : '10'))
      }
      else {
        commit(types.SET_SCREEN_LAYOUT, '00')
        commit(types.SET_DISP_ITEM, '1')
        commit(types.SET_CAROUSEL_INTERVAL, '10')
      }
    },
  },
  mutations: {
    /* ～ver2.5
    // Change screen view mode
    [types.CHANGE_SCREEN_VIEW] (state, screenView) {
      state.sScreenView = screenView
      sLog.verbose('@store screen view changed : ' + state.sScreenView)
      localStorage.setItem(LS_SCREEN_VIEW, screenView)
    },
    // Change columns for screen view mode
    [types.CHANGE_SCREEN_COLUMN] (state, screenColumn) {
      state.sScreenColumn = screenColumn
      sLog.verbose('@store columns for screen view changed : ' + state.sScreenColumn)
      localStorage.setItem(LS_SCREEN_COLUMN, screenColumn)
    },
    */
    // Change screen layout
    [types.SET_SCREEN_LAYOUT] (state, screenLayout) {
      state.sScreenLayout = screenLayout
      sLog.verbose('@store screen layout changed : ' + state.sScreenLayout)
      localStorage.setItem(LS_SCREEN_LAYOUT, screenLayout)
    },
    // Change disp item (screen mode)
    [types.SET_DISP_ITEM] (state, dispItem) {
      state.sDispItem = dispItem
      sLog.verbose('@store disp item changed : ' + state.sDispItem)
      localStorage.setItem(LS_DISP_ITEM, dispItem)
    },
    // Change carousel interval (screen mode)
    [types.SET_CAROUSEL_INTERVAL] (state, interval) {
      state.sCarouselInterval = interval
      sLog.verbose('@store carousel interval changed : ' + state.sCarouselInterval)
      localStorage.setItem(LS_CAROUSEL_INTERVAL, interval)
    },
    // Change gnss ready
    [types.CHANGE_GNSS_READY] (state, gnssReady) {
      state.sGnssReady = gnssReady
      sLog.verbose('@store gnss ready changed : ' + state.sGnssReady)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/system-settings.js